<template>
    <div>
        <the-navbar/>
        <v-app-bar app color="primary" dark>
            <v-app-bar-nav-icon
                v-on:click.stop="toggleDrawer"
            ></v-app-bar-nav-icon>
            <v-spacer></v-spacer>
            <template v-if="$store.state.auth.user !== null">
                <v-icon>mdi-account</v-icon>
                <span class="mx-1">{{$store.state.auth.user.email}} </span>
            </template>
            <v-btn v-on:click="logoutUser" icon class="mx-1">
                <v-icon>mdi-power</v-icon>
            </v-btn>
            <the-progress />
        </v-app-bar>
        <v-main>
            <v-container fluid>
                <router-view />
            </v-container>
        </v-main>
    </div>
</template>
<script>
import { mapMutations, mapActions } from 'vuex'
import snackbar from '@/utils/snackbar'

export default {
  components: {
    'the-navbar': () => import('@/components/NavBar.vue'),
    'the-progress': () => import('@/components/Progress.vue')

  },
  methods: {
    ...mapMutations({
      setDrawer: 'app/SET_DRAWER'
    }),
    ...mapActions({
      logout: 'auth/logout'
    }),
    async logoutUser () {
      await this.$store.dispatch('auth/logout')
      this.$router.replace('/')
      snackbar.show('Logged out')
    },
    toggleDrawer () {
      this.setDrawer(!this.$store.state.app.drawer)
    }
  }
}
</script>
